import { useSuspenseRegionais } from '@/features/regionais/hooks'
import type { TUnidadesDeNegocioDisponiveisData } from '@/features/regionais/interfaces/unidade-de-negocio.types'
import { Icon } from '@/shared/components/icon'
import { DropdownMenuItem, Skeleton } from '@/shared/components/ui'
import { AlertDialogTrigger } from '@/shared/components/ui/alert-dialog'

interface RegionalListProps {
  user: { unidadeDeNegocioId: string }
  onClick: (regional: TUnidadesDeNegocioDisponiveisData) => void
}

export const ListaRegionais = ({ user, onClick }: RegionalListProps) => {
  const { data: regionais } = useSuspenseRegionais()

  return (
    <div className="max-h-[60vh] overflow-auto md:max-h-[80vh]">
      {regionais?.unidadesDisponiveis.map((regional) => (
        <AlertDialogTrigger
          asChild
          key={regional.id}
          disabled={regional.id === user?.unidadeDeNegocioId}
          className="cursor-pointer data-[disabled]:opacity-100"
        >
          <DropdownMenuItem
            key={regional.id}
            onClick={() => onClick(regional)}
            data-active={regional.id === user?.unidadeDeNegocioId}
            className="group gap-2 p-2 data-[active=true]:text-red-800"
            data-testid={`regional-item-${regional.id}`}
          >
            <div className="flex size-6 items-center justify-center rounded-md border">
              <Icon name="building" className="size-4 shrink-0 data-[active=true]:text-red-800" />
            </div>
            {regional.nome}
            <Icon
              name="dot"
              className="ml-auto size-6 text-xs tracking-widest text-red-800 group-data-[active=false]:last:hidden"
            />
          </DropdownMenuItem>
        </AlertDialogTrigger>
      ))}
    </div>
  )
}

export const ListaRegionaisSkeleton = () => {
  return (
    <>
      <div className="flex gap-1" data-testid="regional-item-skeleton">
        <Skeleton className="mb-2 h-8 w-8 animate-pulse" />
        <Skeleton className="mb-2 h-8 w-full animate-pulse" />
      </div>
      <div className="flex gap-1">
        <Skeleton className="mb-2 h-8 w-8 animate-pulse" />
        <Skeleton className="mb-2 h-8 w-full animate-pulse" />
      </div>
      <div className="flex gap-1">
        <Skeleton className="mb-2 h-8 w-8 animate-pulse" />
        <Skeleton className="mb-2 h-8 w-full animate-pulse" />
      </div>
      <div className="flex gap-1">
        <Skeleton className="mb-2 h-8 w-8 animate-pulse" />
        <Skeleton className="mb-2 h-8 w-full animate-pulse" />
      </div>
    </>
  )
}
